// extracted by mini-css-extract-plugin
module.exports = {"container":"electionTypeResult_container__1wYL5","generalResult":"electionTypeResult_generalResult__29MW2","chartResult":"electionTypeResult_chartResult__3SGfz"};